import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useIsAuthenticated, useMsal } from '@azure/msal-react'
import { useEffect } from 'react'
import { loginRequest } from '@/auth/msalConfig'
import { Box, Button, Typography, Paper } from '@mui/material'

export const Route = createFileRoute('/login')({
  component: LoginPage,
})

function LoginPage() {
  const { instance } = useMsal()
  const isAuthenticated = useIsAuthenticated()
  const navigate = useNavigate()

  useEffect(() => {
    if (isAuthenticated) {
      void navigate({ to: '/' })
    }
  }, [isAuthenticated, navigate])

  const handleLogin = () => {
    void instance.loginRedirect({ ...loginRequest, prompt: 'select_account' })
  }

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'background.default',
        p: 2,
      }}
    >
      <Paper
        elevation={0}
        sx={{
          p: { xs: 3, md: 5 },
          maxWidth: 440,
          width: '100%',
          textAlign: 'center',
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 0,
        }}
      >
        <Box
          component="img"
          src="/i4talentLogo.svg"
          alt="i4talent"
          sx={{ width: 200, mb: 3 }}
        />
        <Typography variant="h5" gutterBottom>
          Klaar om te groeien?
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
          Log in met je Microsoft-account en bekijk jouw Road4Success.
        </Typography>
        <Button
          variant="contained"
          fullWidth
          size="large"
          onClick={handleLogin}
        >
          Aanmelden met Microsoft
        </Button>
      </Paper>
    </Box>
  )
}